import TriggerTemplateSummary from './TriggerTemplateSummary';

export default TriggerTemplateSummary;
